import { InMemoryCache, ReactiveVar, makeVar } from "@apollo/client";
import { Modals, initialState as initialModalState } from "./model/modal";
import { App, initialState as initialAppState } from "./model/app";
import {
  offsetLimitPagination,
  paginationForDeliveryOrder,
} from "../graphql/utils";

export const cache: InMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        scUsers: offsetLimitPagination(["keyword", "order"]),
        htUsers: offsetLimitPagination(["keyword", "order"]),
        haudyUsers: offsetLimitPagination(["keyword", "order"]),
        medicalInstitutions: offsetLimitPagination(["keyword", "order"]),
        deliveryOrders: paginationForDeliveryOrder(["keywords", "order"]),
        deliveryOrdersWithKeywords: paginationForDeliveryOrder([
          "keywords",
          "order",
        ]),
        modalState: {
          read() {
            return modalsVar();
          },
        },
        appState: {
          read() {
            return appVar();
          },
        },
      },
    },
  },
});

export const modalsVar: ReactiveVar<Modals> =
  makeVar<Modals>(initialModalState);
export const appVar: ReactiveVar<App> = makeVar<App>(initialAppState);

export type LocalQuery = {
  modalState: Modals;
  appState: App;
};
